import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import Skeleton from '@mui/material/Skeleton';

const LoadingSlides = () => {
  return (
      <div className="recommend-container loading-slides-container">
        <button className="back-to-home loading-slides-back">
          <i className="bi bi-arrow-left" />
        </button>
      <Swiper
        modules={[Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        pagination={{
          clickable: true
        }}
        className="recommend-swiper"
      >
        {[1, 2, 3].map((i) => (
          <SwiperSlide key={i}>
            <div className="artist-slide">
              <div className="artist-slide-background" style={{ background: '#121212' }} />
              <div className="artist-slide-overlay" />
             
              <div className="artist-content">
                <div className="relative">
                  <Skeleton
                    variant="rectangular"
                    width={300}
                    height={300}
                    animation="wave"
                    sx={{
                      bgcolor: 'grey.900',
                      borderRadius: 8,
                      margin: '0 auto'
                    }}
                  />
                </div>
                <Skeleton
                  variant="text"
                  width={200}
                  height={40}
                  animation="wave"
                  sx={{
                    bgcolor: 'grey.900',
                    margin: '1rem auto'
                  }}
                />
               
                <Skeleton
                  variant="text"
                  width={300}
                  height={24}
                  animation="wave"
                  sx={{
                    bgcolor: 'grey.900',
                    margin: '0.5rem auto'
                  }}
                />
                <div className="albums-container mt-8">
                  <Skeleton
                    variant="text"
                    width={150}
                    height={24}
                    animation="wave"
                    sx={{
                      bgcolor: 'grey.900',
                      marginBottom: 2
                    }}
                  />
                  <div className="albums-grid">
                    {[1, 2, 3].map((albumIndex) => (
                      <div key={albumIndex}>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={0}
                          animation="wave"
                          sx={{
                            bgcolor: 'grey.900',
                            borderRadius: 4,
                            paddingTop: '100%' // Aspect ratio 1:1
                          }}
                        />
                        <Skeleton
                          variant="text"
                          width="80%"
                          height={20}
                          animation="wave"
                          sx={{
                            bgcolor: 'grey.900',
                            marginTop: 1
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
                <Skeleton
                  variant="rectangular"
                  width={300}
                  height={48}
                  animation="wave"
                  sx={{
                    bgcolor: 'grey.900',
                    borderRadius: 24,
                    margin: '2rem auto 0'
                  }}
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      </div>
  );
};

export default LoadingSlides;